import { z } from "zod";

// Session schemas
export const SessionInfoSchema = z.object({
  session_id: z.string(),
  tenant: z.string(),
  session_dir: z.string(),
  created_at: z.string(),
  last_activity: z.string().nullable(),
  last_modified: z.string().nullable(),  // When session was last updated
  first_message: z.string().nullable(),
});

export const CreateSessionRequestSchema = z.object({
  tenant: z.string().default("demo"),
  trace: z.boolean().default(false),
  live: z.boolean().default(false),
  max_steps: z.number().optional(),
  skill: z.enum(["charter", "scope-manager", "time-manager", "status-tracker", "kb-lookup", "general"]).optional(),
  // Allow both OpenAI and Claude model strings.
  model: z.string().default("gpt-4o-mini"),
});

export const SendMessageRequestSchema = z.object({
  text: z.string(),
  skill_command: z.enum(["/charter", "/scope-manager", "/time-manager", "/status-tracker", "/kb-lookup", "/general"]).optional(),
  stream: z.boolean().default(false),
  trace: z.boolean().optional(),
  model: z.string().optional(),
  web_search_enabled: z.boolean().optional(),
});

// File upload schemas
export const FileUploadResponseSchema = z.object({
  success: z.boolean(),
  file_path: z.string(),
  file_name: z.string(),
  file_size: z.number(),
  message: z.string(),
});

export const SendMessageResponseSchema = z.object({
  text: z.string(),
  intent: z.string(),
  route_reason: z.string(),
  skill: z.string().nullable(),
  artifacts: z.array(z.string()),
  trace_path: z.string().nullable(),
  turn_id: z.number(),
});

// Worklog schemas
export const WorklogEntrySchema = z.object({
  ts: z.string(),
  tenant: z.string(),
  intent: z.string().nullable(),
  route_reason: z.string().nullable(),
  skill: z.string().nullable(),
  skill_display: z.string().nullable(),
  user: z.string(),
  assistant: z.string(),
  turn_id: z.number(),
  trace_path: z.string().nullable(),
});

export const WorklogResponseSchema = z.object({
  entries: z.array(WorklogEntrySchema),
});

// Artifact schemas
export const ArtifactInfoSchema = z.object({
  path: z.string(),
  size: z.number().nullable(),
  modified: z.string().nullable(),
});

export const ArtifactListResponseSchema = z.object({
  artifacts: z.array(ArtifactInfoSchema),
});

// Tenant schemas
export const TenantInfoSchema = z.object({
  tenant: z.string(),
  root: z.string(),
  neo4j_uri: z.string(),
});

export const TenantListResponseSchema = z.object({
  tenants: z.array(TenantInfoSchema),
});

// Save plan schemas
export const SavePlanResponseSchema = z.object({
  path: z.string(),
  success: z.boolean().default(true),
});

// Type exports
export type SessionInfo = z.infer<typeof SessionInfoSchema>;
export type CreateSessionRequest = z.infer<typeof CreateSessionRequestSchema>;
export type SendMessageRequest = z.infer<typeof SendMessageRequestSchema>;
export type SendMessageResponse = z.infer<typeof SendMessageResponseSchema>;
export type FileUploadResponse = z.infer<typeof FileUploadResponseSchema>;
export type WorklogEntry = z.infer<typeof WorklogEntrySchema>;
export type WorklogResponse = z.infer<typeof WorklogResponseSchema>;
export type ArtifactInfo = z.infer<typeof ArtifactInfoSchema>;
export type ArtifactListResponse = z.infer<typeof ArtifactListResponseSchema>;
export type TenantInfo = z.infer<typeof TenantInfoSchema>;
export type TenantListResponse = z.infer<typeof TenantListResponseSchema>;
export type SavePlanResponse = z.infer<typeof SavePlanResponseSchema>;

